module.exports = __webpack_public_path__ + "static/media/money.d7c2e979.png";